import { useEffect, useState } from "react"

import { Fade, Grid, LinearProgress } from "@mui/material"

import LogoWithSynapse from "../../../assets/LogoWithSynapse.svg?react"

import styles from "./LoadingScreen.module.scss"

const LoadingScreen = ({ isLoading }: { isLoading: boolean }) => {
  const [loadingProgress, setLoadingProgress] = useState(0)

  /**
   * Drives the loading progress bar: increments periodically while isLoading is true, then jumps to 100% when loading finishes.
   * Cleans up the interval on unmount or when isLoading changes.
   */
  useEffect(() => {
    let progressInterval: number | NodeJS.Timeout
    if (isLoading) {
      setLoadingProgress(0)
      progressInterval = setInterval(() => {
        setLoadingProgress((oldProgress) => {
          const newProgress = Math.min(oldProgress + 10, 90)
          return newProgress
        })
      }, 500)
    } else {
      setLoadingProgress(100)
    }

    return () => {
      if (progressInterval) {
        clearInterval(progressInterval)
      }
    }
  }, [isLoading])

  return (
    <Grid container direction="row" justifyContent="center" alignItems="flex-start" className={styles.loadingContainer}>
      <Grid item className={styles.loadingProgress}>
        <LinearProgress
          variant="determinate"
          value={loadingProgress}
          color="primary"
          sx={{
            "&.MuiLinearProgress-root": {
              backgroundColor: "var(--blue-background-2)",
            },
            "&.MuiLinearProgress-root > span": {
              backgroundColor: "var(--blue-background-1)",
            },
          }}
        />
      </Grid>
      <Grid item sx={{ textAlign: "center" }}>
        <Fade in={isLoading} timeout={1200}>
          <div>
            <LogoWithSynapse />
          </div>
        </Fade>
      </Grid>
    </Grid>
  )
}
export default LoadingScreen
